/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isFixedSize", "hasDataRow", "children", "testId", "isLoading"];
import "./dynamic-table.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @repo/internal/react/require-jsdoc */

import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

import { B100, B50, B75, N10, N40 } from '@atlaskit/theme/colors';
var fixedSizeTableStyles = null;
var tableStyles = null;
var bodyBorder = null;
export var Table = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isFixedSize = _ref.isFixedSize,
    hasDataRow = _ref.hasDataRow,
    children = _ref.children,
    testId = _ref.testId,
    isLoading = _ref.isLoading,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("table", _extends({
    inert: isLoading ? '' : undefined,
    ref: ref
  }, rest, {
    "data-testid": testId && "".concat(testId, "--table"),
    className: ax(["_1bsb1osq _yq5hus1c _btyzidpf _ect41gqc", isFixedSize && "_1kqm1n9t", hasDataRow && "_179rralu"]),
    style: _objectSpread(_objectSpread({}, {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, ".concat(N10, ")"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, ".concat(B50, ")"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, ".concat(B75, ")"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, ".concat(B100, ")")
    }), {}, {
      "--_k02y3n": ix("2px solid ".concat("var(--ds-border, ".concat(N40, ")")))
    })
  }), children);
});
var captionStyles = null;
export var Caption = function Caption(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("caption", {
    className: ax(["_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"])
  }, children);
};
var paginationWrapperStyles = null;
export var PaginationWrapper = function PaginationWrapper(_ref3) {
  var children = _ref3.children,
    testId = _ref3.testId;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId && "".concat(testId, "--pagination--container"),
    className: ax(["_1e0c1txw _1bah1h6o"])
  }, children);
};